import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/** Shared list surface — open canvas + one strong table — plan/35. */
export function AdminList(props: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <ul
      className={cn(
        "m-0 mt-6 list-none divide-y divide-[var(--color-border)]/90 overflow-hidden rounded-[var(--radius-xl)] border border-[var(--color-border)]/90 bg-[var(--color-card)] p-0 shadow-[var(--shadow-soft)] animate-[fadeIn_260ms_ease-out]",
        props.className,
      )}
    >
      {props.children}
    </ul>
  );
}

export function AdminListRow(props: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <li
      className={cn(
        "flex items-center justify-between gap-4 px-4 transition-colors hover:bg-[var(--color-background)]/55 active:bg-[var(--color-background)]/80",
        "py-[var(--desk-row-y)]",
        props.className,
      )}
    >
      {props.children}
    </li>
  );
}
